import { render, staticRenderFns } from "./Form2View.vue?vue&type=template&id=74e62dea"
import script from "./Form2View.vue?vue&type=script&setup=true&lang=ts"
export * from "./Form2View.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Form2View.vue?vue&type=style&index=0&id=74e62dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports